/** Convierte texto a slug para categorías de normatividad. */
export function slugifyNormatividadCategory(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 50);
}

/** @typedef {{ id: string, label: string, description: string, orden?: number, activa?: boolean|number, documentos_count?: number }} NormatividadCategory */

const FALLBACK_CATEGORIES = [
  {
    id: 'asamblea',
    label: 'Documentos de asamblea',
    description: 'Actas, convocatorias y documentos derivados de las asambleas de asociados.',
  },
  {
    id: 'reglamentos',
    label: 'Reglamentos de la institución',
    description: 'Estatutos, reglamentos internos y lineamientos oficiales de la cooperativa.',
  },
];

/** @param {Array<Record<string, unknown>>|null|undefined} rows */
export function mapNormatividadCategories(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return FALLBACK_CATEGORIES;
  return rows.map((c) => ({
    id: String(c.slug ?? c.id ?? ''),
    label: String(c.label ?? c.slug ?? ''),
    description: String(c.description ?? ''),
    orden: Number(c.orden) || 0,
    activa: c.activa,
    documentos_count: Number(c.documentos_count) || 0,
  }));
}

/** @param {string} id @param {NormatividadCategory[]} [categories] */
export function getNormatividadCategoryLabel(id, categories = []) {
  const list = categories.length ? categories : FALLBACK_CATEGORIES;
  return list.find((c) => c.id === id)?.label ?? id;
}

/** @param {Array<Record<string, unknown>>|null|undefined} items @param {NormatividadCategory[]} [categories] @param {{ includeInactive?: boolean }} [options] */
export function groupNormatividadByCategory(items, categories = [], options = {}) {
  const { includeInactive = false } = options;
  const list = categories.length ? categories : FALLBACK_CATEGORIES;
  const cats = list.filter((cat) => {
    if (includeInactive) return true;
    return cat.activa !== false && cat.activa !== 0;
  });

  return cats
    .map((cat) => ({
      ...cat,
      documentos: (items ?? []).filter((doc) => doc.categoria === cat.id),
    }))
    .filter((section) => section.documentos.length > 0);
}

export { FALLBACK_CATEGORIES as NORMATIVIDAD_FALLBACK_CATEGORIES };
